export const aboutData = {
  brandName: "在线吃瓜官网",
  heroTitle: "做最真实的吃瓜平台",
  heroSubtitle: "不造谣 · 不传谣 · 只搬运事实",
  intro: "在线吃瓜官网成立于2024年，是国内领先的娱乐八卦资讯聚合平台。我们致力于为吃瓜群众提供最新、最全、最真实的网红塌房和黑料爆料内容。平台每日更新，所有内容均经过严格核实，确保每一条爆料都有据可查。",
  stats: [
    { value: "10万+", label: "日活跃用户" },
    { value: "5万+", label: "累计爆料帖" },
    { value: "1000+", label: "塌房事件追踪" },
  ],
  testimonials: [
    {
      id: 1,
      name: "资深吃瓜群众",
      username: "@chigua_lao",
      avatarUrl: "https://readdy.ai/api/search-image?query=Dark%20portrait%20photography%2C%20abstract%20silhouette%20of%20a%20person%2C%20dramatic%20red%20and%20black%20lighting%2C%20moody%20atmosphere%2C%20minimal%20dark%20background%2C%20editorial%20style%2C%20professional%20photography&width=80&height=80&seq=avatar-01&orientation=squarish",
      quote: "这个网站更新速度太快了，我每天早上第一件事就是刷一遍在线吃瓜官网，比刷微博还勤快！",
    },
    {
      id: 2,
      name: "娱乐主编小王",
      username: "@xiaowang_editor",
      avatarUrl: "https://readdy.ai/api/search-image?query=Dark%20portrait%20photography%2C%20abstract%20human%20silhouette%2C%20moody%20crimson%20lighting%2C%20editorial%20style%2C%20dark%20atmosphere%2C%20minimal%20background%2C%20professional%20photography%2C%20noir%20inspired&width=80&height=80&seq=avatar-02&orientation=squarish",
      quote: "作为同行，我很佩服你们的选题角度和深度。很多其他平台不敢报道的内容，你们这里都能第一时间看到。",
    },
    {
      id: 3,
      name: "吃瓜少女阿琳",
      username: "@alin_chigua",
      avatarUrl: "https://readdy.ai/api/search-image?query=Dark%20abstract%20portrait%2C%20female%20silhouette%20with%20warm%20glow%2C%20dramatic%20lighting%2C%20moody%20atmosphere%2C%20editorial%20style%2C%20dark%20background%2C%20professional%20photography&width=80&height=80&seq=avatar-03&orientation=squarish",
      quote: "全网最好吃的瓜都在这里了！每天蹲点刷新，错过一个瓜感觉错过一个亿。已经推荐给所有闺蜜了。",
    },
    {
      id: 4,
      name: "理性吃瓜人老张",
      username: "@zhang_rational",
      avatarUrl: "https://readdy.ai/api/search-image?query=Dark%20abstract%20portrait%2C%20male%20silhouette%2C%20dramatic%20red%20and%20black%20lighting%2C%20moody%20atmosphere%2C%20editorial%20style%2C%20dark%20background%2C%20professional%20photography%2C%20noir%20inspired&width=80&height=80&seq=avatar-04&orientation=squarish",
      quote: "看了一圈吃瓜网站，就数你们信息最全面。而且每篇都有证据链，不是凭空捏造，这点真的太难得了。",
    },
    {
      id: 5,
      name: "八卦前线记者",
      username: "@frontline_reporter",
      avatarUrl: "https://readdy.ai/api/search-image?query=Dark%20abstract%20portrait%20photography%2C%20human%20silhouette%20with%20camera%2C%20dramatic%20crimson%20lighting%2C%20editorial%20style%2C%20moody%20atmosphere%2C%20dark%20background%2C%20professional%20photography&width=80&height=80&seq=avatar-05&orientation=squarish",
      quote: "你们的爆料速度甚至比我们传统媒体还快，好几个选题我都是从你们这里看到线索然后去深挖的。",
    },
    {
      id: 6,
      name: "深夜吃瓜人",
      username: "@late_night_chigua",
      avatarUrl: "https://readdy.ai/api/search-image?query=Dark%20abstract%20portrait%2C%20silhouette%20with%20phone%20screen%20glow%2C%20dramatic%20red%20lighting%2C%20moody%20noir%20atmosphere%2C%20editorial%20style%2C%20dark%20background%2C%20professional%20photography&width=80&height=80&seq=avatar-06&orientation=squarish",
      quote: "熬夜看你们的网站已经成为习惯了。前天那个大瓜我凌晨两点看到的，第二天早上就爆了，爽！",
    },
  ],
  ctaTitle: "有猛料？我们欢迎投稿！",
  ctaSubtitle: "如果你有独家爆料，欢迎联系我们。严格保护爆料人隐私。",
  ctaButton: "📩 商务合作 / 投稿联系",
  contactEmail: "chigua@zaixianchigua.com",
  socialLinks: [
    { name: "微博", icon: "ri-weibo-line", url: "#" },
    { name: "微信公众号", icon: "ri-wechat-line", url: "#" },
    { name: "抖音", icon: "ri-tiktok-line", url: "#" },
  ],
};